import React from 'react'
import styled from 'styled-components'
import type { ResidentEntry } from '../../utils/stockAlertsTypes'
import ResidentStockItem from './ResidentStockItem'

type Props = {
  title: string
  entries: ResidentEntry[]
}

const StockSection = ({ title, entries }: Props) => {
  const withAlerts = entries.filter(
    (entry) =>
      (entry.outOfStock?.length > 0 || entry.lowStock?.length > 0) && entry.name
  )

  if (withAlerts.length === 0) return null

  return (
    <Section>
      <Heading>{title}</Heading>
      <List>
        {withAlerts.map((entry) => (
          <ResidentStockItem key={entry.id} resident={entry} />
        ))}
      </List>
    </Section>
  )
}

const Section = styled.div`
  margin-bottom: 24px;
`

const Heading = styled.h2`
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 16px 24px;
  color: #333;
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export default StockSection
